import WebClient from '@services/utils/WebClient';

import { type ICreateCheckoutInputData } from './dtos/create/InputData';
import { type ICheckoutRepository } from './ICheckoutRepository';

interface ICreateBody {
  card: {
    expiration: {
      month: number;
      year: number;
    };
    holder: {
      address: {
        city: string;
        complement: string | null;
        neighborhood: string;
        number: string;
        postal_code: string;
        state: string;
        street: string;
      };
      document: string;
      name: string;
    };
    number: string;
    security_code: string;
  };
  installments: number;
  plan_id: number;
}

class CheckoutService implements ICheckoutRepository {
  public async create(inputData: ICreateCheckoutInputData): Promise<void> {
    await WebClient.post<unknown, ICreateBody>({
      path: 'orders',
      body: {
        card: {
          holder: {
            address: {
              postal_code: inputData.card.holder.address.postalCode,
              street: inputData.card.holder.address.street,
              number: inputData.card.holder.address.number,
              complement: inputData.card.holder.address.complement,
              neighborhood: inputData.card.holder.address.neighborhood,
              city: inputData.card.holder.address.city,
              state: inputData.card.holder.address.state,
            },
            document: inputData.card.holder.document,
            name: inputData.card.holder.name,
          },
          expiration: {
            month: inputData.card.expiration.month,
            year: inputData.card.expiration.year,
          },
          number: inputData.card.number,
          security_code: inputData.card.securityCode,
        },
        installments: inputData.installments,
        plan_id: inputData.planId,
      },
    });
  }
}

export default new CheckoutService();
